(function () {
    'use strict';

    angular
        .module('sod.helper')
        .factory('CommonHelper', CommonHelper);

    function CommonHelper(lodash) {
        return {
            isEmpty: isEmpty,
            bytesToSize: bytesToSize,
        };

        function isEmpty(value) {
            if (lodash.isNumber(value)) {
                return lodash.isNaN(value);
            } else {
                if (lodash.isDate(value)) {
                    return false;
                }
                return lodash.isEmpty(value);
            }
        }

        function bytesToSize(bytes) {
            var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            if (bytes == 0) return '0 Byte';
            var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
            return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
        }
    }
})();